export default "__VITE_ASSET__8cec897c__"